// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"xq-z","slideIn":"yq-z"};